import React, { SVGProps } from 'react';

const CardPaypal: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 64 64'
        width={24}
        height={24}
        {...props}
    >
        <path
            fill='#179BD7'
            d='M49.626 19.26c-.048.307-.102.62-.164.963-2.128 10.898-9.397 14.674-18.687 14.674h-4.731a2.295 2.295 0 0 0-2.266 1.925l-2.408 15.37-.688 4.332a1.21 1.21 0 0 0 1.197 1.398h8.358a2.013 2.013 0 0 0 1.994-1.701l.08-.43 1.58-10.025.1-.549a2.023 2.023 0 0 1 2.022-1.666h1.251c8.131 0 14.49-3.299 16.366-12.855.78-3.992.375-7.323-1.68-9.664a7.93 7.93 0 0 0-2.324-1.772Z'
        />
        <path
            fill='#222D65'
            d='M47.402 18.374a15.2 15.2 0 0 0-2.065-.457 26.158 26.158 0 0 0-4.17-.308H28.531a2.02 2.02 0 0 0-1.994 1.709l-2.685 17.029-.077.482a2.295 2.295 0 0 1 2.267-1.925h4.733c9.29 0 16.559-3.773 18.687-14.688.061-.329.116-.643.163-.965a11.078 11.078 0 0 0-1.748-.737l-.477-.14h.002Z'
        />
        <path
            fill='#253B80'
            d='M26.54 19.318a2.01 2.01 0 0 1 1.12-1.506c.274-.124.572-.184.872-.174h12.636c1.395-.01 2.789.09 4.17.303.696.11 1.386.262 2.064.457l.48.15a11.56 11.56 0 0 1 1.749.736c.63-4.035 0-6.782-2.186-9.27C45.037 7.25 40.7 6.079 35.146 6.079h-16.12a2.306 2.306 0 0 0-2.267 1.928l-6.742 42.6a1.381 1.381 0 0 0 1.363 1.604h9.973l2.498-15.863 2.689-17.03Z'
        />
    </svg>
);

export default CardPaypal;
